import type { FaireProductEntity } from "../../entity_types/product";

export const p_bn3ggn39hu: FaireProductEntity = {
  token: "p_bn3ggn39hu",
  type: "product",
  name: "18K Gold Dainty Singapore Chain Necklace, DNA Gold Chain Necklace, sku#EF151",
  brandToken: "b_4f46qpq5wu",
  brandName: "BestBeads&Beyond",
  imageUrl:
    "https://cdn.faire.com/fastly/70f7ec4545fbf485fffb6f6e5fbe976b32f5695204932c29e21218b1aba5b251.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bdb69c677e4f1a092abd55106150861be5b327a99f0c923dcbe8751e6fa0af60.jpeg",
    "https://cdn.faire.com/fastly/c587b7f5fefc83d9282e67bbf73c02650221996d50b80efa25d61ff3df4ffeb4.jpeg",
    "https://cdn.faire.com/fastly/7d7550203f4fe11ccfbb9806ad8cfc8297e5b976322da93c997b849e515cb6f3.jpeg",
    "https://cdn.faire.com/fastly/e1ebdb049fbca9dad1ab7b84368ad787e215c73c6c1e841e00aaaf9a3a621c28.jpeg",
  ],
  priceDollars: 6.85,
  description:
    "\nLength:16inch with 2inch extension\n\nMaterial: Gold Filled\n\nWidth: 1.8mm\n",
  tags: [],
  msrpDollars: 13.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:50.139Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
